import React from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const ColorField = (props: any) => {
  const { placeholder, value, register, errors, label } = props;
  return (
    <>
      <div className={tw`w-full my-2 text-left mt-4`}>
        <label htmlFor="">{label}</label>
        <input
          placeholder={placeholder}
          defaultValue={value}
          {...register}
          type={"color"}
          className={tw`w-full h-9 focus:outline-none bg-[#EEF5F4] mt-1`}
        />
        {errors && (
          <p className={tw`text-red-500 text-xs my-1`}>{errors?.message}</p>
        )}
      </div>
    </>
  );
};

export default ColorField;
